import { Divider, Flex, Typography } from 'antd';
import type { IBtlDocument } from '@api/documents/types';
import { CustomerFilesListItem } from './CustomerFilesListItem';

export interface ICustomerFilesListProps {
  documents?: IBtlDocument[];
}

const customerFilesScrollClassName =
  'h-full overflow-x-hidden overflow-y-auto rounded-lg bg-white scrollbar-thin [scrollbar-color:#d1d5db_#ffffff] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-white [&::-webkit-scrollbar-thumb]:rounded-sm [&::-webkit-scrollbar-thumb]:bg-gray-300 hover:[&::-webkit-scrollbar-thumb]:bg-gray-400';

export const CustomerFilesList = ({ documents }: ICustomerFilesListProps) => {
  const list = documents ?? [];

  return (
    <div className='w-full overflow-hidden rounded-2xl bg-white'>
      <div className='px-6 py-3'>
        <Typography.Text className='mb-0 text-lg font-bold leading-8'>Customer files</Typography.Text>
      </div>
      <Divider className='my-0' />
      <div className='box-border h-[328px] overflow-hidden bg-white p-6'>
        <div className={customerFilesScrollClassName}>
          <Flex vertical className='w-full gap-2'>
            {list.map(doc => (
              <CustomerFilesListItem key={doc.id} document={doc} />
            ))}
          </Flex>
        </div>
      </div>
    </div>
  );
};
